// extracted by mini-css-extract-plugin
export default {"formGrid":"styles_formGrid__7e0I2","buttonContainer":"styles_buttonContainer__7OOFX","switchContainer":"styles_switchContainer__y8Nva","switchItem":"styles_switchItem__3VxPC"};